export default function MuiMenuItem(theme: any) {
  return {
    MuiMenuItem: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {

          },
        },
      ],
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: 'tranparent',
          },

        },
      },
    },
  };
}
